export enum Action {
  VIEW = 'view',
  CLICK = 'click',
}
